// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.home-btn[data-v-3b8392f4]{display:grid;justify-items:center;padding:18px 0;grid-gap:3px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;font-size:12px}a.home-btn[data-v-3b8392f4]:hover{border-bottom:2px solid transparent}", ""]);
// Exports
module.exports = exports;
